import React from 'react'
import { useQuery } from '@apollo/react-hooks'
import { GET_LOCATION_DATA } from 'operations/Location'
import { CSVLink } from "react-csv"

import './travelTimeDisplay.scss'

export default function ({ children: travelTime, type = 'TIME', radius, isocrones, map, exportLocations, onClose }) {

    if (type === 'DISTANCE') return (
        <div className='travelTimeDisplay'>
            <i className='material-icons'>directions_car</i>
            { travelTime } km
            <div className='travelTimeDisplay__actions'>
                <button type='button' onClick={() => {
                    const center = radius.getCenter()
                    map.panTo({ lat: center.lat(), lng: center.lng() })
                }}><i className='material-icons'>my_location</i></button>
                <LocationData exportLocations={ exportLocations }/>
                <button type='button' onClick={() => onClose && onClose()}><i className='material-icons'>close</i></button>
            </div>
        </div>
    )

    return (
        <div className='travelTimeDisplay'>
            <i className='material-icons'>directions_car</i>
            { Math.floor(travelTime / 60) } min
            <div className='travelTimeDisplay__actions'>
                <button type='button' onClick={() => {
                    // const isocrone = isocrones[0].getPath().getArray()
                    let isocrone = []
                    isocrones.map(path => {
                        const paths = path.getPath().getArray()
                        if (paths.length > isocrone.length) {
                            return isocrone = paths
                        }
                        return null
                    })
                    // isocrone.map(path => console.log(path))
                    const latCoords = []
                    const lngCoords = []
                    isocrone.map(path => {
                        latCoords.push(path.lat())
                        return lngCoords.push(path.lng())
                    })
                    const latMax = Math.max(...latCoords)
                    const latMin = Math.min(...latCoords)
                    const lngMax = Math.max(...lngCoords)
                    const lngMin = Math.min(...lngCoords)
                    const latCenter = latMin + ((latMax - latMin) / 2)
                    const lngCenter = lngMin + ((lngMax - lngMin) / 2)
                    map.panTo({ lat: latCenter, lng: lngCenter })
                }}><i className='material-icons'>my_location</i></button>
                {/* <button type='button'><i className='material-icons'>get_app</i></button> */}
                <LocationData exportLocations={ exportLocations }/>
                <button type='button' onClick={() => onClose && onClose()}><i className='material-icons'>close</i></button>
            </div>
        </div>
    )
}

const headers = [
    { label: "Aims ID", key: "id" },
    { label: "Channel Segment", key: "channelSegment" },
    { label: "Map Type", key: "mapType" },
    { label: "Company Name", key: "companyName" },
    { label: "Address", key: "address" },
    { label: "Suite", key: "suiteNumber" },
    { label: "City", key: "city" },
    { label: "Province", key: "province" },
    { label: "Postal", key: "postal" },
    { label: "Phone", key: "phone" },
    { label: "Contact Name", key: "contactName" },
    { label: "Title", key: "title" },
    { label: "Gender", key: "gender" },
    { label: "Employment Size", key: "locationEmploymentSize" },
    { label: "Credit Ratingg", key: "creditRating" },
    { label: "Parts Potential", key: "partsPotential" },
    { label: "Sales Volume", key: "locationSalesVolume" }
];

function LocationData({ exportLocations }) {

    const { error, loading, data } = useQuery(GET_LOCATION_DATA, { variables: { ids: exportLocations }, skip: !exportLocations })

    if (loading) return null
    if (error) return `Error! ${error.message}`

    if (!data) return null

    const locations = []
    data && data.locations && data.locations.map(location => {
        return locations.push({
            ...location,
            phone: `="${ location.phone }"`,
            locationEmploymentSize: `="${ location.locationEmploymentSize }"`,
            partsPotential: `="${ location.partsPotential || '' }"`,
            locationSalesVolume: `="${ location.locationSalesVolume.replace(",","") }"`
        })
    })

    return <CSVLink data={locations} headers={headers} enclosingCharacter={``} filename={"AIMS_Data.csv"}><button type='button'><i className='material-icons'>get_app</i></button></CSVLink>
}